/* Visionneuse plein écran pour la galerie produit : clic pour agrandir, glisser/flèches pour naviguer */
(function () {
  if (window.__montreLightbox) return;
  window.__montreLightbox = true;

  var overlay, imgEl, counterEl, items = [], index = 0, startX = 0, startY = 0, moved = false, downX = 0, downY = 0;

  function big(src) {
    try {
      var u = new URL(src, location.href);
      u.searchParams.set('width', '1800');
      return u.toString();
    } catch (e) { return src; }
  }

  function collect(gallery) {
    var seen = {}, list = [];
    gallery.querySelectorAll('.product-media-gallery-main-slider .splide__slide').forEach(function (li) {
      if (li.classList.contains('splide__slide--clone')) return;
      var im = li.querySelector('.product-media img');
      if (!im) return;
      var src = im.currentSrc || im.src;
      var key = (src || '').split('?')[0];
      if (!key || seen[key]) return;
      seen[key] = true;
      list.push({ src: big(im.src || src), alt: im.alt || '', key: key, el: im });
    });
    return list;
  }

  function build() {
    overlay = document.createElement('div');
    overlay.className = 'montre-lightbox';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Photos du produit');
    overlay.innerHTML =
      '<button type="button" class="montre-lightbox__close" aria-label="Fermer">&times;</button>' +
      '<button type="button" class="montre-lightbox__nav montre-lightbox__prev" aria-label="Photo précédente">&#10094;</button>' +
      '<img class="montre-lightbox__img" alt="" draggable="false">' +
      '<button type="button" class="montre-lightbox__nav montre-lightbox__next" aria-label="Photo suivante">&#10095;</button>' +
      '<div class="montre-lightbox__counter"></div>';
    document.body.appendChild(overlay);
    imgEl = overlay.querySelector('.montre-lightbox__img');
    counterEl = overlay.querySelector('.montre-lightbox__counter');
    overlay.querySelector('.montre-lightbox__close').addEventListener('click', close);
    overlay.querySelector('.montre-lightbox__prev').addEventListener('click', function (e) { e.stopPropagation(); go(-1); });
    overlay.querySelector('.montre-lightbox__next').addEventListener('click', function (e) { e.stopPropagation(); go(1); });
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    overlay.addEventListener('touchstart', function (e) { startX = e.changedTouches[0].clientX; startY = e.changedTouches[0].clientY; }, { passive: true });
    overlay.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - startX, dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? 1 : -1);
    }, { passive: true });
    document.addEventListener('keydown', function (e) {
      if (!overlay.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') go(1);
      else if (e.key === 'ArrowLeft') go(-1);
    });
  }

  function show() {
    var it = items[index];
    imgEl.src = it.src;
    imgEl.alt = it.alt;
    counterEl.textContent = (index + 1) + ' / ' + items.length;
    overlay.classList.toggle('is-single', items.length < 2);
  }

  function go(d) {
    if (items.length < 2) return;
    index = (index + d + items.length) % items.length;
    show();
  }

  function open(list, i) {
    if (!overlay) build();
    items = list; index = i; show();
    overlay.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }

  function close() {
    overlay.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    imgEl.removeAttribute('src');
  }

  document.addEventListener('pointerdown', function (e) { downX = e.clientX; downY = e.clientY; moved = false; }, true);
  document.addEventListener('pointermove', function (e) { if (Math.abs(e.clientX - downX) > 8 || Math.abs(e.clientY - downY) > 8) moved = true; }, true);

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;
    if (t.closest('.splide__arrow, .splide__pagination, button, a')) return;
    var im = t.closest('.product-media-gallery-main-slider .product-media img');
    if (!im || moved) return;
    var gallery = im.closest('product-media-gallery');
    if (!gallery) return;
    var list = collect(gallery);
    if (!list.length) return;
    var key = (im.currentSrc || im.src || '').split('?')[0];
    var i = 0;
    list.forEach(function (it, k) { if (it.key === key) i = k; });
    open(list, i);
  });

  var css = document.createElement('style');
  css.textContent =
    '.product-media-gallery-main-slider .product-media img{cursor:zoom-in}' +
    '.montre-lightbox{position:fixed;inset:0;z-index:2147483000;display:none;align-items:center;justify-content:center;background:rgba(0,0,0,.92)}' +
    '.montre-lightbox.is-open{display:flex}' +
    '.montre-lightbox__img{max-width:96vw;max-height:88vh;object-fit:contain;user-select:none;-webkit-user-select:none;touch-action:pinch-zoom}' +
    '.montre-lightbox__close{position:absolute;top:10px;right:14px;width:44px;height:44px;border:0;background:transparent;color:#fff;font-size:36px;line-height:1;cursor:pointer}' +
    '.montre-lightbox__nav{position:absolute;top:50%;transform:translateY(-50%);width:48px;height:64px;border:0;background:rgba(255,255,255,.12);color:#fff;font-size:26px;cursor:pointer;border-radius:6px}' +
    '.montre-lightbox__nav:hover{background:rgba(255,255,255,.25)}' +
    '.montre-lightbox__prev{left:12px}.montre-lightbox__next{right:12px}' +
    '.montre-lightbox.is-single .montre-lightbox__nav{display:none}' +
    '.montre-lightbox__counter{position:absolute;bottom:14px;left:0;right:0;text-align:center;color:#fff;font-size:14px}' +
    '@media (max-width:749px){.montre-lightbox__nav{width:40px;height:52px;font-size:22px}}';
  document.head.appendChild(css);
})();
